import type { DealDocumentResource } from '@majuscule/contracts';
import { internalFetchBlob } from '../../lib/api';

/**
 * Open a deal document in a new tab (lot 21): a link at its address; a stored
 * PDF through the API (the bearer token is needed, so it is fetched then shown
 * from a blob URL).
 */
export async function openDealDocument(document: DealDocumentResource): Promise<void> {
  if (document.kind === 'link' && document.url !== null) {
    window.open(document.url, '_blank', 'noopener,noreferrer');
    return;
  }
  // Open the tab synchronously (popup blockers), then point it at the PDF.
  const tab = window.open('', '_blank');
  const blob = await internalFetchBlob(`/internal/crm/documents/${document.id}/content`);
  const url = URL.createObjectURL(blob);
  if (tab === null) {
    window.location.assign(url);
    return;
  }
  tab.location.href = url;
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 60_000);
}
